(function () {
  const collectionSlider = () => {
    $(".section-collection-slider").each(function () {
      if ($(this).hasClass("slider_started")) return;

      $(this).addClass("slider_started");

      const id = $(this).attr("id");
      const box = $(this).find(".collection_slider");

      const speed = box.data("speed") * 1000;
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;

      if (autoplay) {
        box.find(".collection-pagination span").addClass("autoplay-active");
      }

      const autoplayParm = autoplay
        ? {
            autoplay: {
              delay: delay,
              disableOnInteraction: false,
            },
          }
        : {};

      /* =====================================================
        IMAGE SWIPER (NO PEEP EVER)
      ====================================================== */
      const imageSwiperParms = {
        speed: speed,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        keyboard: true,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            effect: "fade",
          },
        },
      };

      const swiperImg = new Swiper(`#${id} .swiper_image_block`, {
        ...imageSwiperParms,
        ...autoplayParm,

        navigation: {
          nextEl: `#${id} .swiper-btn--next`,
          prevEl: `#${id} .swiper-btn--prev`,
        },

        pagination: {
          el: `#${id} .swiper-pagination`,
          renderBullet(index, className) {
            return `<span class="${className}">0${index + 1}</span>`;
          },
        },

        on: {
          slideChangeTransitionStart(swiper) {
            const bullets = document.querySelectorAll(
              `#${id} .swiper-pagination-bullet`
            );
            const activeIndex = swiper.realIndex;

            bullets.forEach((bullet, index) => {
              bullet.classList.remove("prev", "next");
              if (index === activeIndex - 1) bullet.classList.add("prev");
              if (index === activeIndex + 1) bullet.classList.add("next");
            });
          },
        },
      });

      /* =====================================================
        PRODUCT / CARD SWIPER (MOBILE PEEP)
        - This affects:
          .collection-grid-card.swiper-slide
      ====================================================== */
      const productSwiperParms = {
        speed: speed,
        slidesPerView: 1.1, // <-- mobile peep
        spaceBetween: 0,
        keyboard: true,
        watchOverflow: true,

        breakpoints: {
          750: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      };

      const swiperText = new Swiper(`#${id} .swiper_product_block`, {
        ...productSwiperParms,
      });

      /* =====================================================
        SYNC SWIPERS
      ====================================================== */
      swiperImg.controller.control = swiperText;
      swiperText.controller.control = swiperImg;

      /* =====================================================
        AUTOPLAY HOVER STOP
      ====================================================== */
      if (autoplay && stopAutoplay) {
        const sliderEl = document.querySelector(
          `#${id} .collection_slider`
        );

        sliderEl.addEventListener("mouseenter", () => {
          swiperImg.autoplay.stop();
          swiperText.autoplay.stop();
        });

        sliderEl.addEventListener("mouseleave", () => {
          swiperImg.autoplay.start();
          swiperText.autoplay.start();
        });
      }
    });
  };

  collectionSlider();

  document.addEventListener("shopify:section:load", function () {
    collectionSlider();
  });
})();
